import "./style.scss";
import PagesHeader from "@components/PagesHeader";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import {
  TERMS_CACHE_TIME,
  TERMS_STALE_TIME,
  getTermDescribe,
  getTermsList,
} from "../../../api/terms";
import { useParams } from "react-router";
import { getModuleValue } from "../../../Helpers";
import DOMPurify from "dompurify";

const dateFormatter = (dateString) => {
  const formattedDate = new Intl.DateTimeFormat("pl-PL", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate.format(new Date(dateString));
};

export default function RegulationPage() {
  const { uuid } = useParams();

  const { data: termData } = useQuery({
    queryKey: ["terms-serve"],
    queryFn: () => getTermDescribe(uuid),
    staleTime: TERMS_STALE_TIME,
    cacheTime: TERMS_CACHE_TIME,
  });

  return (
    <section className="regulation-inner-page">
      <PagesHeader back>
        <strong>Allgemeine Bestimmungen</strong>
      </PagesHeader>

      <div className="regulations-wrapper">
        <div className="regulations-content">
          <p className="term-date">
            <span>Veröffentlicht: </span>
            {dateFormatter(termData.validFrom)}
          </p>
          <h2
            className="term-title"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(termData.content?.title)}}
          ></h2>
          <div className="bg-contener"></div>
          <p
            className="term-des"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(termData.content?.description),
            }}
          ></p>
          <p
            className="terms-content"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(getModuleValue(
                termData?.content?.modules,
                "text",
                "custom"
              )),
            }}
          ></p>
        </div>
      </div>
    </section>
  );
}
